import { CoveragePremiumInterface, CoveragePremiumProductInterface } from '@app/core/interfaces';
import { createSelector } from '@ngrx/store';
import { NotificationInterface } from 'outshared-lib';
import * as fromProductPanel from '../product-panel/product-panel.actions';
import * as fromProduct from '../product/product.actions';
import * as fromCalculations from './calculation.actions';

/** @deprecated use outshared-lib - InsurancePolicyDataService */
export interface State {
    ids: number[];
    entities: { [id: string]: CoveragePremiumInterface };
    selectedId: number;
    loading: boolean;
    loaded: boolean;
    notifications: NotificationInterface[];
}

/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const initialCalculationsState: State = {
    ids: [],
    entities: {},
    selectedId: null,
    loading: false,
    loaded: false,
    notifications: [],
};

/** @deprecated use outshared-lib - InsurancePolicyDataService */
export function reducer(
    state: State = initialCalculationsState,
    action: fromCalculations.CalculationsActions | fromProduct.ProductsActions | fromProductPanel.ProductPanelActions,
): State {
    switch (action.type) {

        case fromCalculations.SET_NOTIFICATIONS: {
            const { notifications } = action.payload;

            if (!notifications) {
                return {
                    ...state,
                    loading: false,
                };
            }

            return {
                ...state,
                loading: false,
                loaded: false,
                notifications,
            };
        }

        case fromCalculations.CLEAR_NOTIFICATIONS:
        case fromCalculations.CANCEL_FUTURE_PURCHASED_COVERAGE:
        case fromCalculations.CHANGE_GENERIC_PURCHASED_COVERAGES: {
            return {
                ...state,
                notifications: [],
            };
        }

        case fromCalculations.LOAD_CALCULATION: {
            return {
                ...state,
                loading: true,
                loaded: false,
            };
        }

        case fromCalculations.LOAD_CALCULATION_SUCCESS: {
            const { calculation, purchased_product_sequence_number } = action.payload;

            if (!calculation) {
                return {
                    ...state,
                    loading: false,
                };
            }

            const entity: CoveragePremiumInterface = Object.assign({}, calculation, { purchased_product_sequence_number });

            return {
                ...state,
                ids: [ ...new Set([...state.ids, purchased_product_sequence_number ]) ],
                entities: {
                    ...state.entities,
                    [purchased_product_sequence_number]: entity,
                },
                loading: false,
                loaded: true,
            };
        }

        case fromCalculations.CHANGE_GENERIC_PURCHASED_COVERAGES_SUCCESS: {
            const { purchased_product_sequence_number, start_date, purchased_coverages } = action.payload;
            const calculation = state.entities[purchased_product_sequence_number];
            const base_coverages = purchased_coverages.filter((coverage) => coverage.base_coverage_indication === 'J');
            const additional_coverage = purchased_coverages.filter((coverage) => coverage.base_coverage_indication !== 'J');
            const product: CoveragePremiumProductInterface = {
                ...calculation.product,
                base_coverages, additional_coverage,
                coverages_adjustment_present_indication: 'J',
                coverages_adjustment_start_date: start_date,
            };

            return Object.assign({}, state, {
                entities: Object.assign({}, state.entities, {
                    [purchased_product_sequence_number]: Object.assign({}, calculation, { product }),
                }),
            });
        }

        case fromCalculations.CANCEL_FUTURE_PURCHASED_COVERAGE_SUCCESS: {
            const { purchased_product_sequence_number, purchased_coverages } = action.payload;
            const calculation = state.entities[purchased_product_sequence_number];
            const base_coverages = purchased_coverages.filter((coverage) => coverage.base_coverage_indication === 'J');
            const additional_coverage = purchased_coverages.filter((coverage) => coverage.base_coverage_indication !== 'J');
            const product: CoveragePremiumProductInterface = {
                ...calculation.product,
                base_coverages,
                additional_coverage,
                coverages_adjustment_present_indication: 'N',
                coverages_adjustment_start_date: null,
            };

            return Object.assign({}, state, {
                entities: Object.assign({}, state.entities, {
                    [purchased_product_sequence_number]: Object.assign({}, calculation, { product }),
                }),
            });
        }

        case fromProductPanel.SELECT: {
            const { selectedId } = action.payload

            return {
                ...state,
                selectedId,
            };
        }

        case fromProduct.MODIFY_FUTURE_PURCHASED_PRODUCT_START_DATE_SUCCESS: {
            const { purchased_product_sequence_number, start_date } = action.payload;
            const calculation = state.entities[purchased_product_sequence_number];

            return {
                ...state,
                entities: {
                    ...state.entities,
                    calculation: {
                        ...calculation,
                        product: {
                            ...calculation.product,
                            coverages_adjustment_start_date: start_date,
                        },
                    },
                },
            };
        }

        case fromCalculations.CLEAR: {
            return initialCalculationsState;
        }

        default: {
            return state;
        }
    }
}

/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getEntities = (state: State) => state.entities;
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getIds = (state: State) => state.ids;
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getSelectedId = (state: State) => state.selectedId;
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getNotifications = (state: State) => state.notifications;
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getSelected = createSelector(getEntities, getSelectedId, (entities, selectedId) => entities[selectedId]);
/** @deprecated use outshared-lib - InsurancePolicyDataService */
export const getAll = createSelector(getEntities, getIds, (entities, ids) => ids.map((id) => entities[id]));
